/**
 * Apply html lang + dir from dashboard language preference.
 */
export function applyDocumentLanguage(lang) {
  const code = lang === "ar" ? "ar" : "en";
  try {
    document.documentElement.lang = code;
    document.documentElement.dir = code === "ar" ? "rtl" : "ltr";
  } catch {
    // ignore
  }
}
